import {
  Component,
  OnInit,
  ChangeDetectorRef,
  ElementRef,
  ViewChild,
} from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { OrganizationService } from '../../../services/organization.service';
import { Router } from '@angular/router';
import { UtilityService } from '../../../services/utility.service';
import { AccountService } from '../../../services/account.service';
import { WatchAccountService } from '../../../services/watch-account.service';
import { Subject } from 'rxjs';
import { GlobalWindow } from '../../../main.window';
import { DynamicScriptLoaderService } from '../../../services/dynamic-script-loader.service';

declare let window: GlobalWindow;

//declare var stripe: any;

@Component({
  selector: 'modal-update-card',
  template: require('./modal-update-card.component.pug'),
  styles: [require('./modal-update-card.component.css').toString()],
})
export class ModalUpdateCardComponent implements OnInit {
  @ViewChild('cardElement') cardElement: ElementRef;

  cardNumber: string;
  public cardName = '';

  card;
  error = null;
  loading = false;
  confirmation;

  elements: any;
  stripe;

  public reason: Subject<any>;

  // Options to pass to the modal:
  plan: string;
  inboxes: number;
  orgId = null;

  // -------------------------------------------------------------------
  constructor(
    public bsModalRef: BsModalRef,
    private organizationService: OrganizationService,
    private router: Router,
    private cd: ChangeDetectorRef,
    private utilityService: UtilityService,
    private accountService: AccountService,
    private watch: WatchAccountService,
    private dynamicScriptLoader: DynamicScriptLoaderService,
  ) {}

  // -------------------------------------------------------------------
  ngOnInit() {
    this.reason = new Subject();

    this.dynamicScriptLoader
      .load('stripe')
      .then(data => {
        this.stripe = Stripe(window.stripe_pub_key);

        const elements = this.stripe.elements();
        //this.card = this.elements.create('card')
        this.card = elements.create('card'); //, { style: this.style });

        this.card.mount(this.cardElement.nativeElement);
        //this.card.mount('#card-element');

        this.card.addEventListener('change', ({ error }) => {
          this.error = error && error.message;
        });

        console.log('Stripe initialized');
      })
      .catch(error => {
        console.error(error);
      });
  }

  // -------------------------------------------------------------------
  onCancel() {
    this.bsModalRef.hide();
  }

  // -------------------------------------------------------------------
  async handleForm(e) {
    e.preventDefault();

    if (!this.cardName || this.cardName.length == 0) {
      this.error =
        'Please enter the cardholder name as it appears on the card first.';
      return;
    }

    this.loading = true;
    this.error = null;

    // for org changing cards (need to clean that up)
    if (this.orgId) {
      this.organizationService.initiateSetupIntent(
        this.orgId,
        this.cardName,
        res => {
          console.log('Got secret, check with Stripe');
          this.stripe
            .handleCardSetup(res.secret, this.card, {
              payment_method_data: {
                billing_details: { name: this.cardName },
              },
            })
            .then(result => {
              if (result.error) {
                // Display error.message in your UI.
                this.error = result.error.message;
                console.error(this.error);
                this.cd.detectChanges();
                this.loading = false;
              } else {
                // The SetupIntent was successful!
                let paymentMethod = result.setupIntent.payment_method;
                console.log('Stripe is OK, letting the server know');

                this.organizationService.completeSetupIntent(
                  this.orgId,
                  paymentMethod,
                  res => {
                    console.log('Card accepted, entering organization...');
                    this.reason.next(true);
                    this.bsModalRef.hide();
                  },
                  error => {
                    console.warn('ERROR:');
                    console.warn({ error });
                    this.error = error;
                    this.loading = false;
                    //this.cd.detectChanges();
                  },
                );
              }
            });
        },
        error => {
          console.warn('STRIPE ERROR:');
          console.warn({ error });
          this.error = error;
          this.loading = false;
          //debugger;
          //this.cd.detectChanges();
        },
      );
      return;
    }

    // for account changing cards
    this.accountService.initiateSetupIntent(
      this.watch.accountId().getValue(),
      this.cardName,
      res => {
        console.log('Got secret, check with Stripe');
        this.stripe
          .handleCardSetup(res.secret, this.card, {
            payment_method_data: {
              billing_details: { name: this.cardName },
            },
          })
          .then(result => {
            if (result.error) {
              // Display error.message in your UI.
              this.error = result.error.message;
              console.error(this.error);
              this.cd.detectChanges();
              this.loading = false;
            } else {
              // The SetupIntent was successful!
              let paymentMethod = result.setupIntent.payment_method;
              console.log('Stripe is OK, letting the server know');

              this.accountService.completeSetupIntent(
                this.watch.accountId().getValue(),
                paymentMethod,
                res => {
                  console.log('Card accepted, entering organization...');
                  this.reason.next(true);
                  this.bsModalRef.hide();
                },
                error => {
                  console.warn('ERROR:');
                  console.warn({ error });
                  this.error = error;
                  this.loading = false;
                  //this.cd.detectChanges();
                },
              );
            }
          });
      },
      error => {
        console.warn('STRIPE ERROR:');
        console.warn({ error });
        this.error = error;
        this.loading = false;
        //debugger;
        //this.cd.detectChanges();
      },
    );
  }
}
